module.exports = __webpack_public_path__ + "img/1.40f6f860.jpg";